import { t } from "@redotech/redo-i18n";
import { StepType } from "@redotech/redo-return-ui/flows/step";
import { BlockLayout } from "@redotech/redo-web/flowchart";

export const EMPTY: StepType<void, never> = {
  description() {
    return "";
  },
  Details() {
    return null;
  },
  customTitle() {
    return undefined;
  },
  downstream() {
    return [];
  },
  maxDownstream() {
    return 0;
  },
  empty: undefined,
  fromModel() {
    throw new Error("Unsupported");
  },
  layout() {
    return BlockLayout.COMPACT;
  },
  toModel() {
    throw new Error("Unsupported");
  },
  Icon() {
    return null;
  },
  stepDeleted(state) {
    return state;
  },
  get title() {
    return t("New step");
  },
  valid() {
    return false;
  },
};
